import { FaCheck } from "react-icons/fa";

import { Checkbox } from "radix-ui";
import { twMerge } from "tailwind-merge";

export const CheckboxComponent = ({
  className,
  ...props
}: Checkbox.CheckboxProps) => (
  <Checkbox.Root
    className={twMerge(
      "border-iron size-3.5 rounded-[2px] border",
      "data-[state=checked]:border-basket-ball-orange",
      className
    )}
    {...props}
  >
    <Checkbox.Indicator
      className={twMerge(
        "text-basketBallOrange flex items-center justify-center"
      )}
    >
      <FaCheck className="size-2" />
    </Checkbox.Indicator>
  </Checkbox.Root>
);
